// extracted by mini-css-extract-plugin
export default {"input":"X15djCOnT79OGHzfFlrA","currency":"GbOtBDme7wYtCAVdQjao"};